'use client';

// Client-only часть runtime-config доменов (Q3-механизм, change `remove-reverse-proxy`).
//
// `RuntimeConfigProvider` монтируется в server-component `app/layout.tsx` (server создаёт
// нормализованный `RuntimeConfig` и передаёт его как prop — стандартный RSC → client
// prop-passing), а client-компоненты потребляют значения через hook `useRuntimeConfig()`.
//
// Тип `RuntimeConfig` и чистая функция `normalizeOrigin()` — в server-safe модуле
// `runtime-config.ts` (этот файл помечен `'use client'`, поэтому его нельзя импортировать
// из server-component `layout.tsx` для вызова `normalizeOrigin` на сервере — это ломало
// SSR с "Attempted to call normalizeOrigin() from the server but normalizeOrigin is on
// the client"). Разделение устраняет эту ошибку.
//
// Контракт: `contract.md` §3 (frontend runtime-config контракт).

import { createContext, useContext } from 'react';
import type { RuntimeConfig } from './runtime-config';

// Default-value context: пустые строки при незаданном домене (провайдер не смонтирован
// или домен не сконфигурирован) — потребители реагируют нейтрально (визитка «Заполните
// поле…», helpdesk-ссылка `aria-disabled`). Контракт §3.3.
const RuntimeConfigContext = createContext<RuntimeConfig>({
  portalOrigin: '',
  helpdeskBaseUrl: '',
});

export function RuntimeConfigProvider({
  value,
  children,
}: {
  value: RuntimeConfig;
  children: React.ReactNode;
}) {
  return (
    <RuntimeConfigContext.Provider value={value}>
      {children}
    </RuntimeConfigContext.Provider>
  );
}

export function useRuntimeConfig(): RuntimeConfig {
  return useContext(RuntimeConfigContext);
}
